module.exports = __webpack_public_path__ + "img/about-bio-1.f844350d.jpg";